import { render } from "./zoomLinkComponent.vue?vue&type=template&id=060e95a4&scoped=true"
import script from "./zoomLinkComponent.vue?vue&type=script&lang=js"
export * from "./zoomLinkComponent.vue?vue&type=script&lang=js"

import "./zoomLinkComponent.vue?vue&type=style&index=0&id=060e95a4&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060e95a4"]])

export default __exports__